module.exports = __webpack_public_path__ + "media/img/frontend_application/content_production/client_4-ee84e586583845e1f5fb7bef92e86b09.png";